module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-05.75ab7f71.jpg";